module.exports = __webpack_public_path__ + "static/media/pos.bc3d9613.jpg";